import { useEffect, useState } from "react";


const useToken = user => {

    const [token, setToken] = useState('');


    useEffect(() => {

        const email = user?.user?.email;
        const currentUser = { email: email };

        if (user) {
            fetch(`https://thawing-wildwood-78264.herokuapp.com/user/${email}`, {

                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(currentUser)
            })
                .then(res => res.json())
                .then(data => {
                    const accessToken = data.token;

                    // save token to local storage
                    localStorage.setItem("accessToken", accessToken);
                    setToken(accessToken);
                })
        }

    }, [user]);

    return [token, setToken];

};

export default useToken;